import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from 'i18next-http-backend';
import { getLocale } from "@/utils/getLocale";

i18n
    .use(HttpApi)
    .use(initReactI18next)
    .init({
        debug: process.env.NODE_ENV === 'development',
        fallbackLng: getLocale(),
        interpolation: {
            escapeValue: false,
        },
        ns: ['translation'],
        defaultNS: 'translation',
        backend: {
            loadPath: `/locales/{{lng}}.json?nocachebrowser=1`,
        },
        lng: getLocale(),
    });

export const t = i18n.t.bind(i18n);

export default i18n;